export enum ResponsibleAreas {
    Moderation,
    Prices
}